export default {
  FETCH_DEVICE_LIST: 'deviceDetails/FETCH_DEVICE_LIST',
};
